// extracted by mini-css-extract-plugin
export var dropdownContainer = "_mf-0";
export var leftAlign = "_mf-4";
export var listItem = "_mf-2";
export var listItemWrapper = "_mf-1";
export var operationText = "_mf-3";